import { useLanguage } from 'Feature/Arrears/components/ArrearsInquiryPage/core/useLanguage';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { arrearsApi } from 'Feature/Arrears/components/ArrearsInquiryPage/api/ArrearsApi';
import { config } from '../../../../../config';
import { Result } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Result';
import { useState } from 'react';

export const useDeleteArrears = () => {
  const { language } = useLanguage();
  const authenticationContext = useAuthenticationContext();
  const api = arrearsApi(authenticationContext, config.arrearsApi.urls.arrears, language);
  const [deletingArrears, setDeletingArrears] = useState<boolean>(false);

  const deleteArrears = async (id: string): Promise<Result<boolean, string[]>> => {
    setDeletingArrears(true);
    const result = await api.del(id);
    setDeletingArrears(false);
    return result;
  };

  return {
    deleteArrears,
    deletingArrears
  };
};
